
export interface BridgeAdapter {
    proposeRoute(route: string): void
    routeTo(route: string): void
}

export class BridgeNavigator {
    restorationId: string
    
    constructor(restorationId: string = 'bridge') {
        this.restorationId = restorationId
    }

    routeTo(_route: string) {
    }
}